import axios from "axios"
import baseURL from "../configs/api"

export const getReservationHistory = (primaryKey: string, tenantId: string) => {
    return getFetch(`reservation/ReservationHistory/${primaryKey}`, tenantId);
}

export const getReservationHistoryByCustomer = (primaryKey: number, tenantId: string) => {
    return getFetch(`reservation/GetReservationsHistoryByCustomer/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}